let _data = [];
let configuration = null;
let isConfigurationSet = false;

export const EVENT = {
  BOC_IFRAME_SUBMIT: 'BOC_IFRAME_SUBMIT',
  BOC_SUBMIT: 'BOC_SUBMIT',
  BOC_EVENT_PAY_SUCCESS: 'BOC_EVENT_PAY_SUCCESS',
  BOC_EVENT_PAY_FAIL: 'BOC_EVENT_PAY_FAIL',
  BOC_EVENT_PAY_ERROR: 'BOC_EVENT_PAY_ERROR',
  BOC_EVENT_CLIENT_VALIDATION: 'BOC_EVENT_CLIENT_VALIDATION',
  BOC_EVENT_SHOW_PROCESSING: 'BOC_EVENT_SHOW_PROCESSING',
  CARD_IFRAME_SUBMIT: 'CARD_IFRAME_SUBMIT',
  CARD_EVENT_PAY_SUCCESS: 'CARD_EVENT_PAY_SUCCESS',
  CARD_EVENT_PAY_FAIL: 'CARD_EVENT_PAY_FAIL',
  CARD_EVENT_CLIENT_VALIDATION: 'CARD_EVENT_CLIENT_VALIDATION',
  CARD_EVENT_SHOW_PROCESSING: 'CARD_EVENT_SHOW_PROCESSING',
  CARD_EVENT_HIDE_PROCESSING: 'CARD_EVENT_HIDE_PROCESSING',
  CARD_EVENT_SESSION_EXPIRED: 'CARD_EVENT_SESSION_EXPIRED',
  CARD_EVENT_CVV_HELPER: 'CARD_EVENT_CVV_HELPER',
  CARD_EVENT_CARD_NOT_SUPPORTED: 'CARD_EVENT_CARD_NOT_SUPPORTED',
  CARD_EVENT_TXN_TOKEN_EXPIRED: 'CARD_EVENT_TXN_TOKEN_EXPIRED',
  CARD_EVENT_CARD_DETAILS: 'CARD_EVENT_CARD_DETAILS',
  CARD_ERROR: 'CARD_ERROR',
  APP_CLOSE: 'APP_CLOSE',
  APP_AUTO_CLOSE: 'APP_AUTO_CLOSE',
  AUTO_LOGIN: 'AUTO_LOGIN',
  BUTTON_CLICK: 'BUTTON_CLICK',
  SELECTED_PAYMODE: 'SELECTED_PAYMODE',
  CLIENT_VALIDATION_INVALID_OTP: 'CLIENT_VALIDATION_INVALID_OTP',
  SC_CVV: 'SC_CVV',
  MERCHANT_CONFIG_ERROR: 'MERCHANT_CONFIG_ERROR',
  INIT: 'INIT',
  INVOKE: 'INVOKE',
  API_INIT: 'API_INIT',
  API_STATUS: 'API_STATUS',
  WALLET_BALANCE_INSUFFICIENT: 'WALLET_BALANCE_INSUFFICIENT',
  MGV_BALANCE_INSUFFICIENT: 'MGV_BALANCE_INSUFFICIENT',
  BALANCE_CHECKED: 'BALANCE_CHECKED',
  COLLECT_FLOW_USED: 'COLLECT_FLOW_USED',
  DISPLAY_UPI_HANDLER_SUGGESTION: 'DISPLAY_UPI_HANDLER_SUGGESTION',
  UPI_HANDLER_SELECTED: 'UPI_HANDLER_SELECTED',
  NB_BANK_SELECTED: 'NB_BANK_SELECTED',
  NB_SEARCH_BAR_USED: 'NB_SEARCH_BAR_USED',
  SC_SUBMIT_DETAILS: 'SC_SUBMIT_DETAILS',
  TXN_STATUS_HANDLED: 'TXN_STATUS_HANDLED',
  PAYMENT_RETRY_AVAILABLE: 'PAYMENT_RETRY_AVAILABLE',
  PAYMODE_SELECTED: 'PAYMODE_SELECTED',
  MANUAL_LOGIN: 'MANUAL_LOGIN',
  LOGIN_SUCCESSFUL: 'LOGIN_SUCCESSFUL',
  IS_INTENT_SUPPORTED: 'IS_INTENT_SUPPORTED',
  CALL_UPI_POLL_INTENT: 'CALL_UPI_POLL_INTENT',
  POLLING_STATUS_CALL: 'POLLING_STATUS_CALL',
  INTENT_SET_TIMEOUT: 'INTENT_SET_TIMEOUT',
  APP_SWITCH: 'APP_SWITCH',
  UPI_INTENT_ACTIVE: 'UPI_INTENT_ACTIVE',
  INTENT_PAY_SUBMIT: 'INTENT_PAY_SUBMIT',
  INTENT_DEEPLINK_INVOKED: 'INTENT_DEEPLINK_INVOKED',
  POLLING_ERROR: 'POLLING_ERROR',
  LOGIN_FPO_RESPONSE: 'LOGIN_FPO_RESPONSE',
  LOGIN_FPO_RESPONSE_ERROR: 'LOGIN_FPO_RESPONSE_ERROR',
  BOC_GET_TXN_TOKEN_PAYLOAD: 'BOC_GET_TXN_TOKEN_PAYLOAD',
  POPUP_WINDOW: 'POPUP_WINDOW',
  DBANK_FEEDBAK_REDIRECT: 'DBANK_FEEDBAK_REDIRECT',
  DBANK_PAGE_EXPIRE: 'DBANK_PAGE_EXPIRE',
  DBANK_PAYON_BANK: 'DBANK_PAYON_BANK',
  DBANK_SUBMIT_PRESSED: 'DBANK_SUBMIT_PRESSED',
  DBANK_CANCEL: 'DBANK_CANCEL',
  DBANK_REDIRECT_INACTIVE: 'DBANK_REDIRECT_INACTIVE',
  DBANK_REDIRECT_OTP_EXPIRED: 'DBANK_REDIRECT_OTP_EXPIRED',
  DBANK_SUBMIT_FAILED: 'DBANK_SUBMIT_FAILED',
  DBANK_SUBMIT_FAILED_BANKRETRY: 'DBANK_SUBMIT_FAILED_BANKRETRY',
  DBANK_SUBMIT_FAILED_REDIRECT: 'DBANK_SUBMIT_FAILED_REDIRECT',
  DBANK_SUBMIT_SUCESS: 'DBANK_SUBMIT_SUCESS',
  DBANK_RESEND_FAILED: 'DBANK_RESEND_FAILED',
  DBANK_RESEND_SUCESS: 'DBANK_RESEND_SUCESS',
  DBANK_RESEND_EXHAUSTED: 'DBANK_RESEND_EXHAUSTED',
  DBANK_CANCEL_NOBUY: 'DBANK_CANCEL_NOBUY',
  DBANK_CANCEL_OTPISSUE: 'DBANK_CANCEL_OTPISSUE',
  DBANK_CANCEL_NOMOBILEACCESS: 'DBANK_CANCEL_NOMOBILEACCESS',
  DBANK_SHOW_PAGE_EXPIRY: 'DBANK_SHOW_PAGE_EXPIRY',
  DBANK_FEEDBACK_OVERLAY: 'DBANK_FEEDBACK_OVERLAY',
  DBANK_FEEDBACK_CLOSE: 'DBANK_FEEDBACK_CLOSE',
  DBANK_UNLOAD: 'DBANK_UNLOAD',
  DBANK_FORM_POST: 'DBANK_FORM_POST',
  RESEND_OTP_CLICK: 'RESEND_OTP_CLICK',
  JOIN_ROOM: 'JOIN_ROOM',
  QR_STATUS: 'QR_STATUS',
  QR_PROCESSING: 'QR_PROCESSING',
  QR_SUCCESS: 'QR_SUCCESS',
  QR_FAIL: 'QR_FAIL',
  PRN_FLOW: 'PRN_FLOW',
  QR_ERROR: 'QR_ERROR',
  QR_SESSION_TIMEOUT: 'QR_SESSION_TIMEOUT',
  WS_CREATE: 'WS_CREATE',
  WS_DISCONNECT: 'WS_DISCONNECT',
  WS_INIT_ERROR: 'WS_INIT_ERROR',
  PRN_VALIDATE_API: 'PRN_VALIDATE_API',
  SUBSCRIPTION_FLOW: 'SUBSCRIPTION_FLOW',
  PRE_PTC_API_CALL_LOG: 'PRE_PTC_API_CALL_LOG',
  REQUEST_ANOTHER_OTP: 'REQUEST_ANOTHER_OTP',
  CHANGE_MOBILE_NUMBER: 'CHANGE_MOBILE_NUMBER',
  REMEMBER_ME: 'REMEMBER_ME',
  UPI_INTENT_HELPER: 'UPI_INTENT_HELPER',
  MOBILE_NUMBER_FOCUS: 'MOBILE_NUMBER_FOCUS',
  MOBILE_NUMBER_FOCUS_ERROR: 'MOBILE_NUMBER_FOCUS_ERROR',
  OTP_FOCUS: 'OTP_FOCUS',
  OTP_FOCUS_ERROR: 'OTP_FOCUS_ERROR',
  UPI_FOCUS: 'OTP_FOCUS',
  UPI_FOCUS_ERROR: 'OTP_FOCUS_ERROR',
  BM_BANK_SELECT: 'BM_BANK_SELECT',
  BM_SELECT_OTHER_BANKS_CLICK: 'BM_SELECT_OTHER_BANKS_CLICK',
  BM_CHANGE_BANK_CLICK: 'BM_CHANGE_BANK_CLICK',
  BM_FIND_IFSC_CLICK: 'BM_FIND_IFSC_CLICK',
  INPUT_ELE_CLICKED: 'INPUT_ELE_CLICKED',
  API_FAILED: 'API_FAILED',
  UPI_INTENT_RETRY: 'UPI_INTENT_RETRY',
  EXCEPTION: 'EXCEPTION',
  LAST_USED_PAYMODE: 'LAST_USED_PAYMODE',
  PERSISTED_ARRAY: 'PERSISTED_ARRAY',
  SAVING_CURRENT_PAYMODE: 'SAVING_CURRENT_PAYMODE',
  INVALID_VPA_ERROR: 'INVALID_VPA_ERROR'
};

export const init = options => {
  if (window.Logger && window.Logger.init) {
    isConfigurationSet = true;
    window.Logger.init(options);
  } else {
    configuration = options;
  }
};

export const log = data => {
  if (window.Logger && window.Logger.log) {
    if (!isConfigurationSet && configuration) {
      isConfigurationSet = true;
      window.Logger.init && window.Logger.init(configuration);
    }
    if (_data.length > 0) {
      _data.forEach(record => {
        try {
          window.Logger.log(record);
        } catch (e) {}
      });
      _data = [];
    }
    window.Logger.log(data);
  } else {
    _data.push(data);
  }
};



// WEBPACK FOOTER //
// ./common/logger.js